import { useState } from 'react';
import newsletterApi from 'ecommerce/api/newsletter';

// Press Sheet signup state shared by the archive page and the newsletter tile. `error` is
// { message, invalid }: `invalid` marks the field for a rejected email, other errors leave it.
const useNewsletterSignup = () => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [subscribedEmail, setSubscribedEmail] = useState(null);

  const onSubmit = async (event) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const email = form.get('email').trim();

    setSubmitting(true);
    setError(null);
    const result = await newsletterApi().subscribe(email, form.get('website'));
    setSubmitting(false);
    if (result.invalid || result.error) {
      setError({ message: result.invalid || result.error, invalid: Boolean(result.invalid) });
      return;
    }
    setSubscribedEmail(email);
  };

  return { submitting, error, subscribedEmail, onSubmit };
};

export default useNewsletterSignup;
